import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'
import { setFirebaseMessagingToken } from '../../../modules/auth/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState
  const { accessToken, firebaseMessagingToken } = auth
  const { registrationToken } = profile

  return {
    registrationToken,
    accessToken,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      waitRenderServer,
      renderServer,
      setFirebaseMessagingToken,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
